import { type HTMLAttributes, memo } from 'react';

import { cn } from '@/shared/utils/cn';

export interface ProfileDetailsGameplayRootProps extends HTMLAttributes<HTMLDivElement> {}

export const ProfileDetailsGameplayRoot = memo(
  function ProfileDetailsGameplayRoot({
    className,
    children,
    ...props
  }: ProfileDetailsGameplayRootProps) {
    return (
      <div className={cn('flex flex-col gap-2', className)} {...props}>
        {children}
      </div>
    );
  },
);
